export class Stage {
    private readonly backgroundModule: HTMLElement | null
    private readonly stageContent: HTMLElement | null
    private readonly stageBackground: HTMLElement | null
    private readonly mobileSizeMediaQuery: MediaQueryList;

    constructor() {
        this.backgroundModule = document.querySelector(".promo-module-background")
        this.stageBackground = document.getElementById("promo_stage-background")
        this.stageContent = document.getElementById("promo_stage-content")
        this.mobileSizeMediaQuery = window.matchMedia("(width < 48em)");
        if (this.mobileSizeMediaQuery.matches) {
            this.splitModuleIntoBackgroundAndContent()
        }
        this.removeNavHeadline()
    }

    private splitModuleIntoBackgroundAndContent(): void {
        if (this.backgroundModule) {
            /*                                                                         */
            const contentContainer = document.createElement("div");
            contentContainer.classList.add("promo-module-foreground");
            this.backgroundModule.parentNode?.insertBefore(contentContainer, this.backgroundModule.nextSibling);

            /*                                                                       */
            if (this.stageContent) {
                const contentNode = this.stageContent.cloneNode(true)
                contentContainer.appendChild(contentNode);
                this.stageContent.remove()
                /*                                      */
                this.addScrollListener(contentNode as HTMLElement);
            }
        }
    }

    private addScrollListener(contentNode: HTMLElement): void {

        let initialYPos = 0;
        const headlineElement = document.querySelector(".promo_staticcontent--stage-widget-headline");

        window.addEventListener("scroll", () => {

            /*                                                                           */
            if (initialYPos == 0) {
                initialYPos = contentNode.getBoundingClientRect().y || 0;
            }

            /*                                                                */
            const yPos = contentNode.getBoundingClientRect().y || 0;
            const differencePx = initialYPos - Math.max(0, yPos)
            const scale = Math.max(1, 1 + (differencePx / initialYPos / 5));
            /*                                                                                    */

            /*                               */
            if (this.stageBackground) {
                this.stageBackground.style.transform = `scale(${scale})`;
            }

            /*                                                                                                      */
            const topOfBackground = (this.backgroundModule?.getBoundingClientRect().top || 0) + 30 /*                                                   */
            const topOfHeadline = headlineElement?.getBoundingClientRect().top
            const topDifferencePx = Math.max(Math.min(80, (topOfHeadline || 0) - topOfBackground), 0)

            const fade = (1 - (topDifferencePx / 80)).toFixed(2);

            /*                                                                                                */
            document.documentElement.style.setProperty("--promo-aggregation-topic-page-two-gradient-opacity", `${fade}`);


        }, {passive: true});
    }


    private removeNavHeadline() {
        const headline = document.querySelector(".nav_grimm-breadcrumb-container__title")
        headline?.remove();
        const container = document.querySelector(".nav_grimm-breadcrumb-container")
        /*                                         */
        container?.removeAttribute("style");
        /*                                                   */
        container?.setAttribute("style", "height:auto;visibility:hidden;");
    }
}